import React, {Component, Fragment} from 'react';
import {Button} from 'reactstrap';
import Dialog from 'apa/containers/Dialog';
import autobind from 'autobind-decorator';
import * as contacts from 'customers/actions/contacts';
import {connect} from 'react-redux';

@connect(
    null,
    dispatch => {
        return {
            remove: (contact) => dispatch(contacts.remove(contact))
        }
    }
)
export default class DeleteContact extends Component {

    constructor(props) {
        super(props);
        this.state = {
            isDeleteContactModalOpen: false
        }
    }

    @autobind
    toggleDeleteContactModal() {
        this.setState({
            ...this.state,
            isDeleteContactModalOpen: !this.state.isDeleteContactModalOpen
        })

    }

    @autobind
    confirmDeleteContact() {
        this.props.remove(this.props.contact);
        this.toggleDeleteContactModal();
    }


    render() {
        return (
            <Fragment>
                    <Button onClick={this.toggleDeleteContactModal} color='danger'>
                        <i className='fa fa-trash'> </i>
                    </Button>
                    <Dialog
                        isOpen={this.state.isDeleteContactModalOpen}
                        toggle={this.toggleDeleteContactModal}
                        confirm={this.confirmDeleteContact}
                        title={'Ansprechpartner löschen'}
                    >
                        Sind Sie Sicher?
                    </Dialog>
            </Fragment>
        )
    }
}